var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-step box-shadow-default"},[_c('el-steps',{attrs:{"align-center":"","active":_vm.activeIndex}},_vm._l((_vm.currentSelecte),function(item,i){return _c('el-step',{key:i,attrs:{"title":item.title}})}),1)],1),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }